import styled from "styled-components";

/* THE CONFIRM PAGE, ONCE.
   Flat white panels, a two-column grid (what and where on the left, the money
   and the pay button in a sticky column on the right), no table chrome. First
   built for RestaurantPlaceOrderScreen; the brand confirm page uses the same
   pieces so the two cannot drift apart. Page and Wrap stay with each page
   because the navbars differ (RestaurantNavBar vs the global Layout). */

export const Heading = styled.h1`
  font-size: 20px;
  letter-spacing: -0.01em;
  margin: 22px 0 4px;
  color: #0f2a2e;
  font-family: "Poppins", sans-serif;
`;

export const SubHeading = styled.p`
  color: #5a6b6d;
  font-size: 13.5px;
  margin: 0 0 22px;
`;

/* minmax(0, 1fr), not 1fr: a bare 1fr track may not shrink below its
   content's min-content width, so one long nowrap line (the delivery address)
   widened the whole column past a phone screen and the page scrolled sideways. */
export const Columns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 20px;
  align-items: start;

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Panel = styled.div`
  background: #ffffff;
  border: 1px solid #e7ecec;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(16, 42, 46, 0.06), 0 8px 24px rgba(16, 42, 46, 0.05);
  overflow: hidden;
`;

export const PanelBody = styled.div`
  padding: 14px 18px 18px;
`;

export const PanelTitle = styled.h2`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #5a6b6d;
  margin: 0;
  padding: 2px 0 8px;
  font-weight: 700;
`;

export const DeliverTo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #e7ecec;
`;

export const Pin = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #eef7f1;
  color: #0a5c40;
  display: grid;
  place-items: center;
  flex: none;
`;

export const DeliverWho = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #0f2a2e;
`;

export const DeliverWhere = styled.div`
  color: #5a6b6d;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* On a phone the chip leaves little room; show the whole address. */
  @media (max-width: 480px) {
    white-space: normal;
  }
`;

export const PayChip = styled.div`
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
  background: #eef7f1;
  color: #0a5c40;
  border: 1px solid #bfe3cd;
  white-space: nowrap;
  flex: none;
`;

export const ItemRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #e7ecec;

  &:first-of-type {
    border-top: 0;
  }
`;

export const Thumb = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 10px;
  object-fit: cover;
  background: #eee;
  flex: none;
`;

export const ItemInfo = styled.div`
  min-width: 0;
`;

export const ItemName = styled.div`
  font-size: 14px;
  font-weight: 550;
  color: #0f2a2e;
`;

export const ItemMeta = styled.div`
  color: #5a6b6d;
  font-size: 12.5px;
`;

export const ItemSum = styled.div`
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  font-size: 14px;
  color: #0f2a2e;
  white-space: nowrap;
`;

export const Summary = styled.div`
  position: sticky;
  /* Clear whichever navbar is fixed above: the global Navbar publishes its
     measured height as --lusuku-nav-h; RestaurantNavBar does not, and the
     fallback keeps that page at the 90px it has always used. */
  top: calc(var(--lusuku-nav-h, 74px) + 16px);

  @media (max-width: 760px) {
    position: static;
  }
`;

export const CostRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  padding: 7px 0;
  color: #0f2a2e;

  .k {
    color: #5a6b6d;
  }
  .v {
    font-variant-numeric: tabular-nums;
  }
`;

export const Rule = styled.div`
  height: 1px;
  background: #e7ecec;
  margin: 8px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 6px;

  .k {
    font-weight: 600;
    color: #0f2a2e;
  }
  .v {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
    font-variant-numeric: tabular-nums;
    color: #0f2a2e;
  }
`;

export const PayLine = styled.div`
  font-size: 12.5px;
  color: #5a6b6d;
  margin-top: 2px;

  b {
    color: #0f2a2e;
    font-weight: 600;
  }
`;

export const FieldRow = styled.div`
  margin-top: 14px;
`;

export const OptionalTag = styled.span`
  color: #8a9a9c;
  font-size: 12px;
  font-weight: 500;
`;

export const EmailHint = styled.div`
  font-size: 12px;
  color: #5a6b6d;
  margin-top: 6px;
`;

export const Cta = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
  padding: 13px 18px;
  border: 0;
  border-radius: 12px;
  background: #03660c;
  color: #ffffff;
  font-size: 15px;
  font-weight: 650;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: #054d0c;
  }

  &:disabled {
    background: #cfd8d7;
    color: #eef2f1;
    cursor: not-allowed;
  }
`;

export const AirtelCta = styled(Cta)`
  background: #e40000;

  &:hover:not(:disabled) {
    background: #b80000;
  }
`;

export const PayLogo = styled.img`
  width: 40px;
  height: 30px;
  border-radius: 5px;
  object-fit: cover;
  margin-right: 10px;
`;

export const Reassure = styled.div`
  text-align: center;
  font-size: 12px;
  color: #5a6b6d;
  margin-top: 10px;
`;
